import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'underscore';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../../analytics-core/services/color.utility.service';

@Component({
	selector: 'app-lift-histogram',
	templateUrl: './lift-histogram.component.html',
	styleUrls: ['./lift-histogram.component.css']
})
export class LiftHistogramComponent implements OnInit, OnChanges {
	@Input() histogramData;
	@Input() chartOptions;
	@Input() liftColor;
	@Output() showLiftRegions = new EventEmitter<any>();
	@Output() hideLiftRegions = new EventEmitter<any>();
	@Output() toggleLiftRegions = new EventEmitter<any>();
	@Input() r7Histogram: any;
	@Input() barChartOptions: any;
	@Input() isR8: any;

	public liftObj: any = {};
	public hideDistributionGraph = true;
	protected selectedBarIndex = -1;
	public secondaryColor: any;
	public mouseOver = true;
	public maxValuesData = [];
	public isR104: boolean = false;

	constructor(protected analyticsDataModel: AnalyticsDataModel, protected colorUtilityService: ColorUtilityService) {}

	ngOnInit() {
		this.isR8 = this.isR8 == 'true' ? true : false;
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.secondaryColor = this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'secondary',
			1
		);
	}

	ngOnChanges() {
		if (!_.isEmpty(this.histogramData)) {
			this.generateHistogram();
			this.secondaryColor = this.colorUtilityService.getHEXByColorType(
				this.analyticsDataModel.partner.colorPalette,
				'secondary',
				1
			);
			this.liftObj = {};
		} else {
			this.hideDistributionGraph = true;
			this.selectedBarIndex = -1;
			this.liftObj = {};
		}
	}

	generateHistogram() {
		const categories = _.keys(this.histogramData);
		const regionsArray = _.pluck(this.histogramData, 'regions');
		const seriesData = [];
		this.maxValuesData = [];
		for (const regions of regionsArray) {
			if (regions) {
				seriesData.push(regions.length);
			}
		}
		const maxValue = Math.max(...seriesData);
		seriesData.forEach((item) => {
			this.maxValuesData.push(maxValue);
		});
		this.hideDistributionGraph = false;
		setTimeout(() => {
			this.drawChart(categories, seriesData);
		}, 100);
		this.selectedBarIndex = -1;
	}

	drawChart(categories, seriesData) {
		let self = this;
		let seriesObj = [];
		if (this.r7Histogram) {
			for (let i = seriesData.length; i < 5; i++) {
				seriesData.push(0);
			}
			seriesObj = [
				{
					color: '#f8f8f8',
					borderWidth: 1,
					grouping: false,
					dataLabels: {
						enabled: false
					},
					enableMouseTracking: false
				},
				{
					states: {
						select: {
							color: '#fed351',
							borderWidth: 1,
							borderColor: '#fff'
						}
					},
					color: this.secondaryColor,
					allowPointSelect: true,
					data: seriesData
				}
			];
		} else if (this.isR8) {
			seriesObj = [
				{
					name: 'Lift',
					data: this.maxValuesData,
					type: 'column',
					color: '#d3d3d3',
					borderWidth: 4,
					borderColor: '#d3d3d3',
					enableMouseTracking: false
				},
				{
					name: 'Lift',
					data: seriesData,
					type: 'column',
					color:
						this.chartOptions && this.chartOptions.graphColor
							? this.chartOptions.graphColor
							: this.colorUtilityService.getHEXByColorType(this.analyticsDataModel.partner.colorPalette, 'primary', 1),
					borderWidth: 4,
					borderColor: '#d3d3d3'
				}
			];
		} else if (this.isR104) {
			seriesObj = [
				{
					name: 'Lift',
					data: seriesData,
					type: 'column',
					color:
						this.chartOptions && this.chartOptions.graphColor
							? this.chartOptions.graphColor
							: this.colorUtilityService.getHEXByColorType(this.analyticsDataModel.partner.colorPalette, 'secondary', 1)
				}
			];
		} else {
			seriesObj = [
				{
					name: 'Lift',
					data: seriesData,
					type: 'column',
					color:
						this.chartOptions && this.chartOptions.graphColor
							? this.chartOptions.graphColor
							: this.colorUtilityService.getHEXByColorType(this.analyticsDataModel.partner.colorPalette, 'primary', 1)
				}
			];
		}
		Highcharts.chart(
			'lift-histogram',
			{
				chart: {
					margin: this.chartOptions && this.chartOptions.margin ? this.chartOptions.margin : [10, 20, 150, 20],
					backgroundColor: 'rgba(255, 255, 255, 0.0)',
					type: this.chartOptions && this.chartOptions.chartType ? this.chartOptions.chartType : 'column',
					width: this.r7Histogram ? 250 : 345,
					height: this.isR8 ? 280 : undefined
				},
				title: {
					text: null
				},
				subtitle: {
					text: null
				},
				xAxis: {
					categories: categories,
					visible: false
				},
				yAxis: {
					title: {
						text: null
					},
					height: '100%',
					tickInterval: Math.max(...seriesData),
					max: this.isR8 ? Math.max(...this.maxValuesData) : Math.max(...seriesData),
					visible: false
				},
				tooltip: {
					enabled: false
				},
				legend: {
					enabled: false
				},
				plotOptions: {
					column: {
						pointPadding: 0,
						borderWidth: 0,
						borderRadius: this.getBorderRadius(),
						pointWidth: this.r7Histogram ? 20 : 30,
						grouping: this.isR8 ? false : undefined
					},
					series: {
						borderWidth: this.r7Histogram ? 1 : 0,
						allowPointSelect: true,
						marker: {
							states: {
								hover: {
									enabled: false
								}
							}
						},
						states: {
							hover: {
								color: this.liftColor
							},
							select: {
								color: this.liftColor
							}
						},
						point: {
							events: {
								mouseOver: (event) => {
									this.mouseOverEvent(event);
								}
							}
						},
						events: {
							mouseOut: (event) => {
								this.mouseOutEvent(event);
							},
							click: (event) => {
								this.clickEvent(event);
							}
						}
					}
				},
				series: seriesObj
			},
			function (chart) {
				if (self.r7Histogram) {
					var series = chart.series[1];
					Highcharts.each(series['yData'], function (p, i) {
						chart.series[0].addPoint({
							pointWidth: p.pointWidth,
							y: Math.max(...series['yData']),
							x: p.x
						});
					});
				}
			}
		);
	}
	getBorderRadius() {
		if (this.r7Histogram) {
			return 2;
		} else if (this.isR8) {
			return 20;
		} else if (this.barChartOptions) {
			return this.barChartOptions?.series?.borderRadius;
		} else {
			return 0;
		}
	}

	mouseOverEvent(eventObj) {
		if (this.mouseOver) {
			this.mouseOver = false;
			const index = eventObj.target.index;
			const selectedLiftObj = this.histogramData[index];
			if (this.selectedBarIndex === -1) {
				this.liftObj = this.histogramData[index];
			}
			if (this.selectedBarIndex !== index) {
				this.toggleLiftRegions.emit({ liftData: selectedLiftObj, toggle: true });
			}
		}
	}

	mouseOutEvent(eventObj) {
		this.mouseOver = true;
		const index = eventObj.target.index;
		if (this.selectedBarIndex === -1) {
			this.liftObj = {};
		}
		if (this.selectedBarIndex !== index) {
			this.toggleLiftRegions.emit({ toggle: false });
		}
	}

	clickEvent(eventObj) {
		const index = eventObj.point.index;
		if (this.selectedBarIndex === index) {
			this.selectedBarIndex = -1;
			this.hideLiftRegions.emit({});
		} else {
			this.selectedBarIndex = index;
			const selectedLiftObj = this.histogramData[index];
			this.liftObj = this.histogramData[index];
			this.showLiftRegions.emit({ liftData: selectedLiftObj });
		}
	}
}
